module.exports = __webpack_public_path__ + "img/stars-img.bdf3ffb9.jpg";